import { httpUtil } from "@repo/lib-web";
import sha1 from "js-sha1";
import { CreateAffiliateUrlRequest } from "./types/createAffiliateUrlRequest";
import { CreateAffiliateUrlParams } from "./types/createAffiliateUrlParams";
import { CreateAffiliateUrlResponse } from "./types/createAffiliateUrlResponse";
import { CreateUserInfoPageUrlParams } from "./types/createUserInfoPageUrlParams";
import { CreateUserInfoPageUrlRequest } from "./types/createUserInfoPageUrlRequest";
import { applyCssFile, prepareOffCanvas } from "./affUtils";
import { logUtil } from "@repo/lib-common";
const createAffialiateUrl = "https://shorten.btrck.com/api/affiliateurl/createurlv2";
const createUserInfoPageUrlTmp = "https://paylaskazan.winfluenced.com"
//const createUserInfoPageUrlTmp = "http://localhost:5266"

export class AdpAffiliateClientV2 {

    utils = { applyCssFile, prepareOffCanvas };

    private getRandomInt(): number {
        return (new Date()).getTime() | 0;
    }

    private hashSha1(sourceStr: string | undefined | null): string {
        let hash = "";
        if (sourceStr === null || sourceStr === undefined || 0 === sourceStr.length) return hash;
        hash = sha1(sourceStr);
        return hash;
    }

    public async createAffialiateUrl(params: CreateAffiliateUrlParams): Promise<CreateAffiliateUrlResponse> {
        const resp = new CreateAffiliateUrlResponse();
        const req = new CreateAffiliateUrlRequest(params);
        req.hostName = window.location.hostname;
        req.r = this.getRandomInt();
        req.appToken = this.hashSha1(`${req.applicationId}-${req.apiKey}-${req.apiSecret}-${req.timeStamp}-${req.userId}-${req.r}`);
        return new Promise<CreateAffiliateUrlResponse>((resolve, reject) => {
            if (!params.apiKey || !params.apiSecret || !params.applicationId || !params.originUrl || !params.userId) {
                resp.isSuccess = false;
                resp.message = 'aff url required params are missing';
                reject(resp);
            }
            try {
                return httpUtil.httpPostPromise({ url: createAffialiateUrl, data: req, contentType: httpUtil.ContentTypeEnum.json })
                    .then((httpRes) => {
                        resp.isSuccess = true;
                        resp.shortenUrl = httpRes.data.shortenUrl;
                        resp.httpStatusCode = httpRes.status;
                        resolve(httpRes.data);
                    }).catch((e) => {
                        resp.isSuccess = false;
                        resp.message = e.message;
                        reject(resp);
                    });

            } catch (error: any) {
                resp.isSuccess = false;
                resp.message = error.message;
                reject(resp);
            }
        });
    }


    private readonly brandsWithCss = ["madamecoco"];
    isCreateAffiliateUrlAndShowInSidePanel_Enabled = true;
    public setCreateAffiliateUrlAndShowInSidePanel_Enabled(isEnabled: boolean) {
        this.isCreateAffiliateUrlAndShowInSidePanel_Enabled = isEnabled;
    }
    public async createAffiliateUrlAndShowInSidePanel(params: CreateAffiliateUrlParams) {
        if (params.brandSlug && this.brandsWithCss.includes(params.brandSlug)) {
            applyCssFile(params.brandSlug);
        }
        if (!this.isCreateAffiliateUrlAndShowInSidePanel_Enabled) return;
        this.setCreateAffiliateUrlAndShowInSidePanel_Enabled(false);
        logUtil.consoleLog("createAffialiateUrl request:", params);
        this.createAffialiateUrl(params).then((data) => {
            prepareOffCanvas(data.shortenUrl!, () => { this.setCreateAffiliateUrlAndShowInSidePanel_Enabled(true); });
        }).catch(err => {
            console?.log("aff url error", err)
        });
    }





    public createUserInfoPageUrl(params: CreateUserInfoPageUrlParams): string {
        const req = new CreateUserInfoPageUrlRequest(params);
        req.r = this.getRandomInt();
        req.appToken = this.hashSha1(`${req.applicationId}-${req.apiKey}-${req.apiSecret}-${req.timeStamp}-${req.userId}-${req.r}`);
        const url = `${createUserInfoPageUrlTmp}/${req.brandSlug}/?t=${req.appToken}&b=${req.userId}&ts=${req.timeStamp}&ak=${req.apiKey}&as=${req.apiSecret}&ai=${req.applicationId}&r=${req.r}`;
        return url;
    }

}

export { AdpAffiliateClientV2 as AdpAffClient };